<template>
  <div class="new-box">
    <keep-alive :include="includes">
      <component
        :is="currentView"
        :active="active"
        @toggle="toggle"
      />
    </keep-alive>
  </div>
</template>
<script>
import News from "./news.vue";
export default {
  name: "DemoIndex",
  components: {
    News,
    News1: (resolve) => require(["./news1.vue"], resolve),
    News2: (resolve) => require(["./news2.vue"], resolve),
    News3: (resolve) => require(["./news3.vue"], resolve),
  },
  data() {
    return {
      active: 0,
      includes: ["News1"],
    };
  },

  mounted() {},
  computed: {
    currentView: function () {
      let retVal = "";
      switch (this.active) {
        case 0:
          retVal = "News"; // 新闻首页
          break;
        case 1:
          retVal = "News1"; // 新闻1
          break;
        case 2:
          retVal = "News2"; // 新闻2
          break;
        case 3:
          retVal = "News3"; // 新闻3
          break;
        default:
          break;
      }
      return retVal;
    },
  },
  methods: {
    toggle(val) {
      this.active = val;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>